import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    homePage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label that opens the Frame.io marketing website in a new tab */
            homePage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MarketingWebsiteMenuItem.homePage?c=ta6kd3l5jt87", defaultMessage: "Frame.io" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
